import styled, { css } from "styled-components";
import { MatrixSizes } from "../../constants/PotentialMatrixConstants";

export const StyledGeneralMatrix = styled.div<{
  $size: MatrixSizes;
}>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  overflow: auto;

  .matrix-general-full-grid {
    display: grid;
    grid-template-columns: max-content repeat(12, 1fr);
    gap: ${(props) => (props.$size === MatrixSizes.BIG ? "10px" : "4px")};
    min-width: max-content;

    & > *:nth-child(13n + 6),
    & > *:nth-child(13n + 10) {
      margin-left: 12px;
    }
  }

  .row-title-cell {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    white-space: nowrap;
    justify-content: center;
    padding-right: 10px;
  }

  .axis-cell {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    text-align: center;
    justify-content: center;
    width: 100%;
  }

  .axis-row-spacer {
    width: 100%;
  }
`;

export const StyledGeneralCell = styled.div<{
  $bgColor: string;
  $size: MatrixSizes;
}>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  border-radius: 8px;
  min-height: 124px;
  min-width: 0;
  background-color: ${(props) => props.$bgColor};
`;

export const StyledGeneralCellContainer = styled.div<{
  $clickable?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 4px;
  cursor: ${(props) => (props.$clickable ? "pointer" : "inherit")};
  transition: all 0.3s ease;

  ${(props) =>
    props.$clickable &&
    css`
      &:hover {
        background-color: rgba(255, 255, 255, 0.7);
      }
    `}
`;

export const StyledCellContentGloabal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const StyledCircleGroupContainer = styled.div<{
  $size: number;
}>`
  position: relative;
  width: ${(props) => `${props.$size}px`};
  height: ${(props) => `${props.$size}px`};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledCircle = styled.div<{
  $size: number;
  $isVisible: boolean;
}>`
  width: ${(props) => `${props.$size}px`};
  height: ${(props) => `${props.$size}px`};
  border-radius: 100%;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 8px 0px rgba(74, 74, 79, 0.2);
  position: absolute;
  visibility: ${(props) => (props.$isVisible ? "visible" : "hidden")};
`;

export const StyledImpactBracket = styled.div`
  border: 1px solid #0e0e0e;
  border-top: transparent;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  width: 100%;
  height: 20px;
`;

export const StyledImpactGroup = styled.div<{ $isFirst?: boolean }>`
  grid-column: span 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-left: ${(props) => (props.$isFirst ? "0" : "12px")};

  .impact-label-content {
    display: flex;
    gap: 10px;
    align-items: center;
  }
`;
